<template>
  <div class="row">
    <div class="closeButton">
        <button class="btn btn-danger" type="button" @click="closeUpdatesScreen">{{translate('close')}}</button>
    </div>
    <div class="col">
      <Version
        v-for="version in allVersions"
        :key="version.number"
        :number="version.number"
        :groups="version.groups">
      </Version>
    </div>
  </div>
</template>

<script>
import Version from '../components/Version.vue'

export default {
    components: {
        Version,
    },
    created(){
        const savedLanguage = localStorage.getItem('language');
        console.log("savedLang", savedLanguage)
        if(this.hideVersionDetails)
            this.$router.push('/' + this.$root.$data.login.Account.Code);
        if(savedLanguage == "tr"){
            this.$router.push('/' + this.$root.$data.login.Account.Code + '/updates')
        }
    },
    methods: {
        closeUpdatesScreen(){
            this.$router.push('/' + this.$root.$data.login.Account.Code);
        }  
    },
    computed: {
        hideVersionDetails(){
        if(this.hasAuth("Admin"))
            return false;
        else
            return window.settings.customization.hideVersionDetails ? true : false;  
        },
        allVersions(){
            return [
                {
                    number : "2.13.2",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "UETS Inbox feature added",
                                "API option added for recipients. You can send documents to your own applications via API option.",
                                "PDF viewer upgraded.",
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Design fixes.",
                                "Security updates.",
                                "Performance updates.",
                                "Integration updates."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.13.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "REM signing added into Mobile App.",
                                "Merge PDF feature added. You can combine multiple PDFs as a document while creating job.",
                                "Bank order screen added.",
                                "REM file size limit upgraded to 35 MB.",
                                "Recipient template feature added. You can proceed by choosing from ready to use recipient definitions.",
                                "Authorized government agency info added while searching by DETSIS."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Design fixes.",
                                "Security updates.",
                                "Performance updates."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.12.2",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "The new version of Imzalayıcı integrated. Added signing feature with macOS.",
                                "SMS notification feature for users is added.",
                                "Banks receipt (file pattern) formats have been added.",
                                "An encrypted file-sending feature is added.",
                                "Specifying the signature standard for each recipient feature is added to prevent the incorrect signature standard selection..",
                                "Multi login feature by Azure is added",
                                "Multi language support added. English is available"
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Design fixes.",
                                "Security updates.",
                                "Bank Order amount fixes."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.12.1",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "The OAuth support for mail sending has been added.",
                                "Document viewing feature for External Signers is added.",
                                "An online payment feature has been added to access documents that come via UETS (Only for Cloud users).",
                                "The requirement to define EYP Recipients before creating an EYP has been removed. You can enter the institution information directly when creating a job.",
                                "Support for determining the minimum number of signatories on a category basis is added.",
                                "Barcode No field has been added for REM messages sent to the Ministry of Justice."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Signature placement errors in some PDF files have been fixed.",
                                "REM Inbox synchronization improvements have been made.",
                                "Design fixes.",
                                "Security updates."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.12.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Incoming Document Module has been added. By filtering your incoming documents, you can direct them to the relevant users/departments.",
                                "UETS Integration has been carried out.",
                                "The feature of signing KEP messages with mobile signature has been added.",
                                "The feature of signing EYP files with mobile signature has been added.",
                                "The feature of signing e-Guarantee letters with mobile signature has been added.",
                                "The option to log the approval processes in a Time Stamped manner by making OTP verification via SMS has been added.",
                                "The ability to sign signed PDF files has been added.",
                                "The feature of signing KEP messages with HSM has been added.",
                                "Ability to save External Users is added.",
                                "Stamp Tax definition feature has been added in the job.",
                                "It is provided that the customer can edit the design and text of the messages sent.",
                                "Signing infrastructure has been renewed.",
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "File previewing options have been arranged.",
                                "Design fixes.",
                                "Security updates."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.11.2",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Added External Signer forwarding feature.",
                                "Document download and viewing feature has been added on the Signature Verification page.",
                                
                               
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Security updates.",
                                "Design fixes."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.11.1",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Special Department Manager authorization has been added to the department assignments of users.",
                                "Serial signature option has been added for CAdES signature profile.",
                                "Added counter signature support for Mobile Signing.",
                                "Long-term signing feature for PDF documents has been added.",
                                "More than one recipient (if any) is displayed on the reports page.",
                                "In EYP submissions, the recipient's DETSİS Number and Institution Name information is displayed on the job detail page."
                               
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Security updates.",
                                "Empty document upload error has been fixed.",
                                "File path error in file system recipients has been fixed."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.11.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "A filter removal button has been added to list all users on the Signer/Approver selection screen.",
                                "The location of the Create EYP button is on the left side of the circulation information page.",
                                "The create job / Save button is named \"save as draft\".",
                                "On the Create Job / Summary page, the contact information added to cc and bcc can be displayed in the recipient section.",
                                "With the Place Visible Signature button, adding more signers than in the flow is prevented.",
                                "On the Visible Signature screen, objects that are not on the relevant page (passive) are completely invisible.",
                                "Since the signature of one of the users is sufficient, instead of the warning \"waiting for your signature\" in the e-mail notification sent to the user who did not sign, an e-mail was sent with the heading \"notification\".",
                                "On the Place Visible Signature page, the verification link, verification code, etc. It is ensured that the contents of the texts cannot be changed.",
                                "Domain filters can be added for Email recipients from Account Parameters."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Security updates."
                            ]
                        }
                    ]
                },
                {
                    number : "2.10.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Security updates."
                            ]
                        }
                    ]
                },
                {
                    number : "2.9.2",
                    groups : [
                        {
                            header : "New Features",
                            notes : 
                            [
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        }
                    ]
                },
                {
                    number : "2.9.1",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "For REM recipients, Detsis Number can be entered in addition to the REM address.",
                                "In SFTP and File system recipients, signed files can be left under a parametrically definable directory.",
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Fixed the issue where 'Place a Visible Signature' was not placed at the specified location when signing a job with Mobile Signature."
                            ]
                        }
                    ]
                },
                {
                    number : "2.9.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Privacy options have been added in the create job screen to identify users who can access circulated files.",                                
                                "'Flow Customization' has been added to create job-specific flows or customize defined flows on the create job screen.",
                                "The order in the list of my works has been made according to the date of the last action.",
                                "The signing formats of the files on the job were shown.",
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        }
                    ]
                },                
                {
                    number : "2.8.3",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        }
                    ]
                },  
                {
                    number : "2.8.1",
                    groups : [
                        {
                            header : "New Features",
                            notes : [                  
                                "Foreigner ID number can be entered in user credentials.",
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        }
                    ]
                },
                {
                    number : "2.8.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [                  
                                "Integration with PTTKep is provided.",                                 
                                "Turkey IDN (TCKN) control over Population Citizenship Affairs of Turkey (NVI) has been made adjustable (active/deactivated) from account parameters.",
                                "User credentials (Turkey IDN (TCKN) and Date of Verification) can only be changed by the logged in user from the 'Edit My Information' screen on the profile page.",
                                "The user lists that appear on the selection screens in the report filters have been filtered on a departmental basis.",
                                "The limitations for the description fields are shown.",
                                "The 'Resend' button for recipients has also been made available to the user who created the job.",
                                "The first or last page can be selected for the default signature location when the signature template is not used. (Can be defined via Account Parameters)",
                                "Adding/removing users to the relevant department from the department definitions screen has been added.",
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "The 'Re-Notify' button has been restricted to appear only for job creators or admin users.",
                                "The Reporting authorization requirement for the 'Revise' button has been removed.",
                                "In case of multiple users in the same step, only the user whose signature is expected is displayed in the Pending User field.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.7.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [                  
                                "Integration with TürkKEP is provided.", 
                                "Improved the mobile compatibility of the External Signer interface.",
                                "Mobile signature fields have been added to the user-defined credentials screen.",
                                "Manual triggering of OnPrem LDAP synchronization has been provided.",                          
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "The problems in the create EYP screen have been fixed.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.6.1",
                    groups : [
                        {
                            header : "New Features",
                            notes : [                                                
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        }
                    ]
                },
                {
                    number : "2.6.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [      
                                "'Outbox' and 'Send New Message' menus have been added for KEP Management Module.",
                                "Added MFA (SMS, E-Signature, Mobile Signature) feature so that external signers can verify their identity before accessing job details.",
                                "Added live alerts to the create job screen.",
                                "For recipients whose recipient type is 'E-Mail', the default e-mail draft is used in the mail content.",
                                "The date format can be determined on account basis.",
                                "Added 'File System' as Receiver type for OnPrem installations.",                                                 
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "Fixed an issue that would not allow circulation if the file limit set for the recipient was zero.",
                                "Recipients connected to a department-independent flow are blocked from department changes.",
                                "The problem where the 'Waiting' column appears blank for jobs waiting for external users in job lists has been fixed.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.5.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [      
                                "REM Management Module has been added.",
                                "Works in circulation can be revised.",
                                "The visuals of the rejection and cancellation steps in the job have been corrected.",
                                "'Signer / Approvee' and 'Sent with REM' filters have been added to the reporting screen.",
                                "The 'Sent with REM' filter has been added to the My Jobs page.",
                                "'Jobs I've Started' link is added to the My Jobs field on the Dashboard screen.",                                
                                "Daily reminder emails is changed as configurable be turned off on a user basis.",
                                "For OnPrem customers, daily reminder e-mails have been developed as customizable, and it is possible to send to demand.",
                                "Integration with ADFS is provided in OnPrem installations.",                                                         
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "It is prevented to add encrypted or unsupported format PDF files for signing when creating a job.",
                                "Descriptions of external signers are now displayed in the workflow.",                                
                                "The error messages left in the file attachment tab after clearing the page on the Create Job screen have been cleared.",
                                "Only users with 'REM Transaction Authorities' can be selected for REM authority definitions.",
                                "The summary data coming from the Job Management field on the Dashboard screen were filtered according to the departments that the user is authorized."
                            ]
                        }
                    ]
                },
                {
                    number : "2.4.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [      
                                "Adjustments were made to the Place Visible Signature screen. (Due to these changes, defined templates need to be recreated)",
                                "Place Signature templates have been customized for the user. All users will be able to create and edit their own templates.",
                                "Attachments can be sent to recipients.",
                                "Account code and user name are automatically brought to the login screen.",
                                "A reminder e-mail can be sent to the waiting user via the workflow steps.",
                                "Integration with Azure AD is provided.",
                                "TCKN information can be entered by users.",
                                "Timestamp dates for signers on the Signature Verification page is added.",
                                "After logging in via the mobile application, it is possible to switch to other companies.",                          
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        }
                    ]
                },
                {
                    number : "2.3.0",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Changed 'Roaming Profile' to 'Flow', 'Target System' to 'Recipient'.",                                
                                "For PDF files, when the file name is clicked, it is displayed in a new tab.",
                                "By removing the Document Type field, Category definitions were created and made definable by users.",
                                "2D signature image can be added instead of the signer name in PDF files.",
                                "Categories-based reporting was provided on the Reports screen.",
                                "During the updating of REM evidence, if the REM session was closed, it was possible to log in again.",
                                "In the receiver definitions, the possibility of limiting the total file size that can be transmitted to the receiver at one time has been provided.",
                                "After the flow starts, it is possible to add an attachment to it.",
                                "Adjustments have been made to improve the user experience in the interface.",
                                "The browser zoom ratio is automatically adjusted according to the user screen resolution.",                                
                                "The password policy has been detailed. Passwords must be at least 8 characters including at least one letter, one number and different from the last three passwords.",
                                "Screens and user information about licenses and modules were arranged.",
                                "Server errors that occur during file upload have been detailed and made more understandable.",
                                "@kep.tr domain control is added while defining REM and Mail recipients.",
                                "The mobile phone information of the user who created the job was removed from the mail notifications.",
                                "Authorization column has been added to the excel output from the user list.",
                                "Session history is added to user profile page.",
                                "Version notes is added.",
                                "Mobile signature feature for external signers is added.",
                                "Additional files can be added by the external signer.",
                                "Security Group based user management for OnPrem Active Directory integration is added.",
                                "Password services integration is provided for OnPrem installations.",
                                "Bug Fixes.",
                                "Security updates."
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "An issue with signer name appearing at the top left of the page is fixed.",
                                "The 'Very Urgent' option has been prevented from appearing in EYP 2.0 packages.",                                
                                "TCKN check has been removed for passive users."
                            ]
                        }
                    ]
                },
                {
                    number : "2.2.1",
                    groups : [
                        {
                            header : "New Features",
                            notes : [
                                "Login feature via mobile signature is added.",
                                "Instruction signing feature in XML format has been added.",
                                "Jobs can be filtered by department.",
                                "Sending of messages with REM message type as eYazisma has been enabled.",
                                "Test feature for SFTP Target System definitions is added.",
                                "Browse button to select remote directory in SFTP Target System definitions is added.",
                                "Signature verification after mobile signing is added.",
                                "Job name from Signature Verification page is removed.",
                                "Only users with the 'Create Job' authorization have been enabled to use the 'Jobs I've Started' filter on the 'My Jobs' page only.",
                                "'kep.tr' domain control in REM and Mail Destination System definitions is added.",
                                "Arrangements were made for viewing and downloading signed/unsigned files in the job.",
                                "TCKN requirement for external signatories has been linked to account parameters.",
                                "The order amount requirement was linked to the account parameters.", 
                            ]
                        },
                        {
                            header : "Bug Fixes",
                            notes : [
                                "App-wide improvements and bug fixes.",
                                "The document type is transferred in the similar job creation process.",
                                "Fixed the issue where the signer's name and surname appeared above the placed position on the Place Signature page.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.2.0",
                    groups : [
                        {
                            notes : [
                                    "External Signer module is added.",
                                    "EYP 2.0 integration is added.",                   
                                    "Active Directory (LDAP) integration for On-Premise installations is added.",
                                    "PDF signature/text layout templates is added.",
                                    "ATemplate design for mail submissions is added.", 
                                    "User-based management of mail notifications has been added.",  
                                    "API integration infrastructure was developed.",
                                    "Bug Fixes.",
                                    "Security updates.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.1.0",
                    groups : [
                        {
                            notes : [
                                    "Mobile app support is added.",
                                    "Bug Fixes.",
                                    "Security updates.",
                            ]
                        }
                    ]
                },
            ];
        }
    }
}

</script>

<style scoped>
.closeButton{
    position: fixed;
    z-index: 999;
    right: 5px;
}
</style>